import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { Text } from '../Text';

const MOBILE_HORIZONTAL_PADDING = 2;
const MOBILE_GUTTER = 0.125;
const ROOM_FOR_EDGES = MOBILE_HORIZONTAL_PADDING * 2 + MOBILE_GUTTER * 2;
const ARROW_OFFSET = MOBILE_HORIZONTAL_PADDING + MOBILE_GUTTER;

export const MobileContainer = styled('div')`
  margin: ${({ theme }) => `${theme.spacing.blockMarginY} 0`};
  overflow: hidden;
`;

export const BlockHeading = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing.ml};
  margin-left: ${MOBILE_HORIZONTAL_PADDING + MOBILE_GUTTER}rem;
  max-width: 12rem;

  ${mediaQueries.desktop} {
    margin-bottom: ${({ theme }) => theme.spacing.xl};
    margin-left: initial;
    text-align: center;
    max-width: none;
  }
`;

export const CarouselContainer = styled('div')`
  width: calc(100% - ${ROOM_FOR_EDGES}rem);
  margin: 0 auto;

  .react-multi-carousel-list {
    overflow: visible;
  }
`;

interface ArrowProps {
  direction: Direction;
}

export type Direction = 'right' | 'left';

export const CustomArrow = styled('button')<ArrowProps>`
  border: 0;
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  position: absolute;
  left: ${({ direction }) =>
    direction === 'left' ? `-${ARROW_OFFSET}rem` : 'auto'};
  right: ${({ direction }) =>
    direction === 'right' ? `-${ARROW_OFFSET}rem` : 'auto'};
`;

interface BlockProps {
  color: string;
}

export const Testimonial = styled('div')<BlockProps>`
  background-color: ${({ theme, color }) =>
    color ? color : theme.color.brand};
  color: ${({ theme }) => theme.color.defaultText};
  padding: ${({ theme }) =>
    `${theme.spacing.xl} ${MOBILE_HORIZONTAL_PADDING}rem`};
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.sliderBlock};
  margin: 0 ${MOBILE_GUTTER}rem;
  flex: 1;

  ${mediaQueries.tablet} {
    padding: ${({ theme }) => `${theme.spacing.l} ${theme.spacing.ml}`};
  }

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.sliderBlock_desktop};
    padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing['2xl']}`};
    height: auto;
  }
`;
